import React from 'react';

import { connect } from 'react-redux';

import {
    tripSummaryActions,
} from 'wanderu-ducks-search';

import TravelerInfo from '../../components/TripSummary/TravelerInfo/TravelerInfo';

function TravelerInfoContainer(props) {
    return (
        <TravelerInfo {...props} />
    );
}

const mapDispatchToProps = {
    setTravelerInfo: tripSummaryActions.setTravelerInfo,
};

export {
    TravelerInfoContainer,
};
export default connect(null, mapDispatchToProps)(TravelerInfoContainer);
